import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

import { Dropdown, Menu, MenuItem, Checkbox } from 'ant-design-vue';
import { FilterFilled } from '@ant-design/icons-vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import { RexFilterItemsType } from '@/rex-components/rex.comp.types';
import { CSSProperties, Ref, computed, ref } from 'vue';
import { useThemeToken } from '@/utils/theme/useThemeToken';

interface Props {
  items: RexFilterItemsType[];
  initialSelectedKeys?: string[];
  overlayStyle?: CSSProperties;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RexFilterFieldV3',
  props: {
    items: {},
    initialSelectedKeys: { default: () => [] },
    overlayStyle: { default: () => ({ width: '15rem' }) }
  },
  emits: ['onFilter'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { token } = useThemeToken();

const selectedKeys = ref(props.initialSelectedKeys);
const openDropdown: Ref<boolean> = ref(false);

const allKeys = computed(() => {
  return props.items.map((obj) => obj.key);
});
function onReset() {
  selectedKeys.value = allKeys.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Dropdown), {
      open: openDropdown.value,
      trigger: "click",
      placement: "bottomRight",
      arrow: false,
      overlayStyle: _ctx.overlayStyle
    }, {
      overlay: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(Menu), {
            selectedKeys: selectedKeys.value,
            "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
            class: "rex-filter-field-menu",
            multiple: true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
                return (_openBlock(), _createBlock(_unref(MenuItem), {
                  key: item.key
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Checkbox), {
                      checked: selectedKeys.value.indexOf(item.key) >= 0,
                      class: "rex-filter-field-checkbox"
                    }, null, 8, ["checked"]),
                    _createTextVNode(" " + _toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selectedKeys"]),
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundColor: _unref(token).colorBgElevated }),
            class: "rex-filter-field-actions-box"
          }, [
            _createVNode(RexButtonV3, {
              variant: "text",
              id: "rex-filter-field-reset-btn",
              class: "rex-filter-field-btn",
              size: "small",
              onOnClick: onReset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('reset')), 1)
              ]),
              _: 1
            }),
            _createVNode(RexButtonV3, {
              id: "rex-filter-field-ok-btn",
              class: "rex-filter-field-btn",
              size: "small",
              onOnClick: _cache[2] || (_cache[2] = 
                () => {
                  openDropdown.value = false;
                  emit('onFilter', selectedKeys.value);
                }
              )
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ok')), 1)
              ]),
              _: 1
            })
          ], 4)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = () => (openDropdown.value = true)),
          class: "rex-filter-field-icon"
        }, [
          _createVNode(_unref(FilterFilled), { style: {
            height: '0.55rem',
            color: 'rgba(255, 255, 255, 0.7)',
          } })
        ])
      ]),
      _: 1
    }, 8, ["open", "overlayStyle"])
  ]))
}
}

})